import { Button } from "@choose/ui/button";
import type { ErrorComponentProps } from "@tanstack/react-router";
import { ErrorComponent, Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export function Error({ error }: ErrorComponentProps) {
  const { t } = useTranslation();

  return (
    <>
      <title>{`${t("error.title")} - ${t("app_name")}`}</title>
      <div className="bg-background h-0 min-h-[768px]">
        <main className="bg-background grid min-h-full place-items-center px-6 py-24 sm:py-32 lg:px-8">
          <div className="text-center">
            <p className="text-selected text-base font-semibold">500</p>
            <h1 className="text-foreground mt-4 text-5xl font-semibold tracking-tight text-balance sm:text-7xl">
              {t("error.title")}
            </h1>
            <p className="text-muted-foreground mt-6 text-lg font-medium text-pretty sm:text-xl/8">
              {t("error.description")}
            </p>
            {import.meta.env.PROD ? null : <ErrorComponent error={error} />}
            <div className="mt-10 flex items-center justify-center gap-x-6">
              <Button
                nativeButton={false}
                render={
                  <Link to="." reloadDocument={true}>
                    {t("error.reload")}
                  </Link>
                }
              />
            </div>
          </div>
        </main>
      </div>
    </>
  );
}
